/* =========================================================================
   Milagron · Ürün kartı kampanya kutusu (44 px)
   -------------------------------------------------------------------------
   Ürün kartlarındaki .custom-tag-rotator--below şeridini yapılandırılmış
   kutuya çevirir: solda büyük değer (%25 / %10 / 3×), sağda iki satır,
   kod içeren kampanyada kopyalanabilir kod çipi.

   Veri kaynağı değişmedi: discount-badge.liquid'in ürettiği data-efx-tags
   JSON'u (panelden yönetilen shop.metafields.badges.discount). Metin,
   oran, kod, fiyat, hangi üründe hangi badge'in çıkacağı yine panelden
   gelir; bu dosya yalnız görünümü kurar.

   Tür tanıma (metinden):
     - sonunda fiyat + metinde %NN  -> sepet  (yeşil)
     - "Kod: XXXX"                 -> kod    (turuncu, kopyala çipi)
     - "N Taksit"                  -> taksit (mavi)
     - diğer                       -> genel  (siyah)

   Eski rotator (layout/theme.liquid) aynı düğümü efxInit bayrağı kurulu
   gördüğü için atlar. Bu dosya o script'ten ÖNCE (head başında, defer'siz)
   yüklenmeli ki MutationObserver ve DOMContentLoaded sırası bizde olsun.
   Marka Vitrini rotator'larında --below sınıfı yok, onlara dokunulmaz.
   ========================================================================= */
(function () {
  'use strict';
  if (window.__mgCbox) return;
  window.__mgCbox = true;

  var SEL = '.custom-tag-rotator--below';
  // Marka Vitrini section'ındaki dönen etiket: aynı kutu, section renklerine uyan sade hâli
  var VIT_SEL = '.efx-bs__tags.custom-tag-rotator';
  var ROT_SEL = SEL + ', ' + VIT_SEL;
  var FADE = 220;
  // Renkler Tema ayarları > Milagron Özel Ayarlar'dan CSS değişkeni olarak gelir
  var ACC = {
    sepet: 'var(--mg-c-sepet, #0B7A43)',
    kod: 'var(--mg-c-kod, #B35A00)',
    taksit: 'var(--mg-c-taksit, #1D3FA8)',
    genel: 'var(--mg-c-genel, #141414)'
  };
  // Davranış ayarları: doc-head-core.liquid window.MG_CBOX olarak basar
  function cfg(k, d) {
    var c = window.MG_CBOX || {};
    return c[k] === undefined || c[k] === null ? d : c[k];
  }
  var COPY_SVG =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><rect x="9" y="9" width="12" height="12" rx="2"/><path d="M5 15V5a2 2 0 0 1 2-2h10"/></svg>';

  var timers = new WeakMap();

  function clean(s) {
    return String(s == null ? '' : s).replace(/\s{2,}/g, ' ').trim();
  }
  function dropPercent(s) {
    return clean(String(s).replace(/%\s*\d+(?:[.,]\d+)?\s*/, ''));
  }

  // Fiyat: "3.599,25 TL", "₺3.599,25", "3.599 TL"
  var PRICE_RE = /\s((?:₺\s?)?\d[\d.]*,\d{1,2}(?:\s?(?:TL|₺))?|(?:₺\s?)?\d[\d.]*\s?(?:TL|₺))\s*$/;

  function parse(it) {
    var text = clean(it.text);
    var pct = /%\s*(\d+(?:[.,]\d+)?)/.exec(text);

    // 1) Sepet: oranlı badge, sonunda hesaplanmış fiyat var
    //    (yeni alanlar gelirse onları kullan: base / rate / suffix / price)
    if (it.price && it.rate != null && it.rate !== '') {
      return {
        kind: 'sepet',
        big: '%' + String(it.rate).replace('.', ','),
        l1: dropPercent(it.base || text) || 'Sepette İndirim',
        sfx: clean(it.suffix),
        price: clean(it.price)
      };
    }
    var pm = pct ? PRICE_RE.exec(text) : null;
    if (pct && pm) {
      var rest = clean(text.slice(0, pm.index));
      var low = rest.toLocaleLowerCase('tr');
      var at = low.lastIndexOf('indirim');
      var head = rest,
        sfx = '';
      if (at >= 0) {
        head = rest.slice(0, at + 7);
        sfx = clean(rest.slice(at + 7));
      }
      return { kind: 'sepet', big: '%' + pct[1], l1: dropPercent(head) || 'Sepette İndirim', sfx: sfx, price: clean(pm[1]) };
    }

    // 2) Kodlu kampanya: "... %10 İndirim | Kod: MILAGRON10"
    var cm = /Kod\s*:\s*([A-Za-z0-9_-]+)/i.exec(text);
    if (cm) {
      var h = clean(text.split('|')[0].replace(/Kod\s*:\s*[A-Za-z0-9_-]+/i, ''));
      var hp = /%\s*(\d+)/.exec(h);
      return { kind: 'kod', big: hp ? '%' + hp[1] : '%', l1: dropPercent(h), code: cm[1] };
    }

    // 3) Taksit
    var tm = /(\d+)\s*Taksit/i.exec(text);
    if (tm) return { kind: 'taksit', big: tm[1] + '×', l1: text };

    // 4) Genel
    return { kind: 'genel', big: pct ? '%' + pct[1] : '', l1: pct ? dropPercent(text) : text };
  }

  var toastEl = null, toastT = null;
  function toast(code) {
    try {
      if (!toastEl) {
        toastEl = document.createElement('div');
        toastEl.className = 'mg-cbox-toast';
        toastEl.setAttribute('role', 'status');
        toastEl.setAttribute('aria-live', 'polite');
        document.body.appendChild(toastEl);
      }
      toastEl.textContent = '';
      var ic = document.createElement('span');
      ic.className = 'mg-cbox-toast__ic';
      ic.textContent = '✓';
      var b = document.createElement('b');
      b.textContent = code;
      toastEl.appendChild(ic);
      toastEl.appendChild(b);
      toastEl.appendChild(document.createTextNode(' ' + cfg('toastText', 'kopyalandı · ödeme adımında yapıştır')));
      toastEl.classList.remove('is-on');
      void toastEl.offsetWidth;
      toastEl.classList.add('is-on');
      clearTimeout(toastT);
      toastT = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400);
    } catch (e) {}
  }

  // ---- Satış fiyatı: kartta .product-price, ürün sayfasında yakındaki fiyat alanı
  var MONEY_RE = /(\d{1,3}(?:\.\d{3})*|\d+),(\d{2})/;
  function moneyOf(t) {
    var m = MONEY_RE.exec(String(t || ''));
    return m ? parseFloat(m[1].replace(/\./g, '') + '.' + m[2]) : 0;
  }
  function priceEl(node) {
    var vc = node.closest('.efx-bs__card');
    if (vc) return vc.querySelector('.efx-bs__price-now');
    var pb = node.closest('.product-block');
    if (pb) return pb.querySelector('.product-price');
    var up = node.parentElement;
    for (var k = 0; up && k < 8; k++, up = up.parentElement) {
      var f = up.querySelector('.product-price, .price-container, .product-detail__price, .price');
      if (f && !node.contains(f) && moneyOf(f.textContent)) return f;
    }
    return null;
  }
  function fmtTL(v) {
    try {
      return v.toLocaleString('tr-TR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' TL';
    } catch (e) {
      return v.toFixed(2).replace('.', ',') + ' TL';
    }
  }

  // ---- Sepet fiyatı fiyatın yanında: mevcut fiyat çizilir, altına "Sepette X TL"
  function rateOf(p) {
    return parseFloat(String(p.big || '').replace('%', '').replace(',', '.')) || 0;
  }
  function applySepetPrice(scope, rate) {
    if (!scope || !rate || !cfg('sepetFiyat', true)) return;
    var box = scope.querySelector('.efx-bs__price') || scope.querySelector('.price');
    if (!box) return;
    var curEl = box.querySelector('.price__current') || box.querySelector('.efx-bs__price-now');
    if (!curEl) return;
    var draw = function () {
      var cur = moneyOf(curEl.textContent);
      var sp = box.querySelector('.mg-sp');
      if (!cur) { if (sp) sp.remove(); box.classList.remove('mg-sp-on'); return; }
      if (!sp) {
        sp = el('div', 'mg-sp');
        sp.appendChild(el('span', 'mg-sp__val'));
        sp.appendChild(el('span', 'mg-sp__tag'));
        box.appendChild(sp);
      }
      var val = fmtTL(Math.round(cur * (100 - rate)) / 100);
      if (sp.firstChild.textContent !== val) sp.firstChild.textContent = val;
      var lbl = cfg('sepetLabel', 'Sepette');
      if (sp.lastChild.textContent !== lbl) sp.lastChild.textContent = lbl;
      box.classList.add('mg-sp-on');
    };
    draw();
    // Ürün sayfasında varyant değişince fiyat değişir
    if (!curEl._mgSpWatch && 'MutationObserver' in window) {
      curEl._mgSpWatch = true;
      new MutationObserver(draw).observe(curEl, { childList: true, subtree: true, characterData: true });
    }
  }
  function sepetFromItems(items) {
    for (var k = 0; k < items.length; k++) {
      var p = parse(items[k]);
      if (p.kind === 'sepet') return rateOf(p);
    }
    return 0;
  }
  function sepetRateFor(node) {
    if (node._mgItems) return sepetFromItems(node._mgItems);
    var box = node.parentElement;
    if (!box) return 0;
    var tags = box.querySelectorAll('.custom-tag:not(.custom-tag-rotator)');
    for (var k = 0; k < tags.length; k++) {
      var t = tags[k].getAttribute('data-mg-text') || tags[k].textContent;
      var p = parse({ text: t });
      if (p.kind === 'sepet') return rateOf(p);
    }
    return 0;
  }
  function pdpScope(node) {
    var up = node.parentElement;
    for (var k = 0; up && k < 8; k++, up = up.parentElement) {
      var pr = up.querySelector('.price .price__current');
      if (pr && !node.contains(pr)) return pr.closest('.price').parentElement;
    }
    return null;
  }

  function el(tag, cls, txt) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (txt != null) e.textContent = txt;
    return e;
  }

  function copyText(t) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        return navigator.clipboard.writeText(t).catch(function () {
          fallbackCopy(t);
        });
      }
    } catch (e) {}
    fallbackCopy(t);
    return Promise.resolve();
  }
  function fallbackCopy(t) {
    try {
      var ta = document.createElement('textarea');
      ta.value = t;
      ta.setAttribute('readonly', '');
      ta.style.cssText = 'position:fixed;top:-1000px;left:-1000px;opacity:0;';
      document.body.appendChild(ta);
      ta.select();
      document.execCommand('copy');
      document.body.removeChild(ta);
    } catch (e) {}
  }

  function render(node, inner, it) {
    var p = parse(it || {});
    var acc = ACC[p.kind];
    // Genel türde panel rengi (beyaz değilse) vurgu olur
    if (p.kind === 'genel' && it && it.bg && !/^#?(fff|ffffff)$/i.test(String(it.bg).trim())) acc = it.bg;

    node.style.setProperty('--mg-acc', acc);
    node.setAttribute('data-mg-kind', p.kind);
    node.classList.toggle('mg-cbox--nobig', !p.big);

    inner.textContent = '';
    inner.appendChild(el('span', 'mg-cbox__big', p.big));
    inner.appendChild(el('span', 'mg-cbox__sep'));
    var txt = el('span', 'mg-cbox__txt');
    txt.appendChild(el('span', 'mg-cbox__l1', p.l1));

    if (p.kind === 'sepet') {
      var l2 = el('span', 'mg-cbox__l2');
      if (p.sfx) l2.appendChild(el('span', 'mg-cbox__sfx', p.sfx));
      l2.appendChild(el('b', 'mg-cbox__price', p.price));
      txt.appendChild(l2);
      inner.appendChild(txt);
      // Dar kartta fiyat sığmazsa önek ("Sadece") gizlenir, fiyat kesilmez
      requestAnimationFrame(function () {
        if (l2.scrollWidth > l2.clientWidth + 1) l2.classList.add('mg-cbox__l2--nosfx');
      });
    } else if (p.kind === 'kod') {
      var row = el('span', 'mg-cbox__l2');
      var btn = el('button', 'mg-cbox__chip');
      btn.type = 'button';
      btn.setAttribute('aria-label', p.code + ' kodunu kopyala');
      var lbl = el('span', 'mg-cbox__code', p.code);
      btn.appendChild(lbl);
      btn.insertAdjacentHTML('beforeend', COPY_SVG);
      var l1el = txt.querySelector('.mg-cbox__l1');
      var l1txt = p.l1;
      var last = 0;
      var doCopy = function (e) {
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        var now = Date.now();
        if (now - last < 600) return; // pointerup + click çift tetiklenmesin
        last = now;
        copyText(p.code);
        btn.classList.remove('is-copied');
        void btn.offsetWidth; // animasyon her tıkta yeniden oynasın
        btn.classList.add('is-copied');
        node.classList.add('mg-cbox--copied');
        lbl.textContent = 'KOPYALANDI';
        if (l1el) l1el.textContent = 'Kod kopyalandı ✓';
        btn.setAttribute('aria-label', 'Kod kopyalandı');
        if (cfg('toast', true)) toast(p.code);
        node._mgPause = now + 2600;
        clearTimeout(btn._mgT);
        btn._mgT = setTimeout(function () {
          btn.classList.remove('is-copied');
          node.classList.remove('mg-cbox--copied');
          lbl.textContent = p.code;
          if (l1el) l1el.textContent = l1txt;
          btn.setAttribute('aria-label', p.code + ' kodunu kopyala');
        }, 2400);
      };
      // Slider/kart tıklama dinleyicileri dokunuşu yutmasın
      ['pointerdown', 'mousedown', 'touchstart'].forEach(function (ev) {
        btn.addEventListener(ev, function (e) { e.stopPropagation(); }, { passive: true });
      });
      btn.addEventListener('pointerup', function (e) {
        if (e.pointerType !== 'mouse') doCopy(e);
      });
      btn.addEventListener('click', doCopy);
      row.appendChild(btn);
      txt.appendChild(row);
      inner.appendChild(txt);
    } else if (p.kind === 'taksit') {
      var n = parseInt(p.big, 10);
      var pe = priceEl(node);
      var total = pe ? moneyOf(pe.textContent) : 0;
      // Sepet indirimi varsa taksit sepet fiyatından hesaplanır
      var srate = sepetRateFor(node);
      if (total > 0 && srate > 0) total = Math.round(total * (100 - srate)) / 100;
      if (n > 1 && total > 0 && cfg('taksitTutar', true)) {
        var tl2 = el('span', 'mg-cbox__l2');
        tl2.appendChild(el('b', 'mg-cbox__price mg-cbox__price--taksit', n + ' × ' + fmtTL(Math.round((total / n) * 100) / 100)));
        txt.appendChild(tl2);
        // Dar kartta "Vade Farksız 3 Taksit" sığmazsa "Vade Farksız" kalır (3× solda yazıyor)
        var tl1 = txt.querySelector('.mg-cbox__l1');
        requestAnimationFrame(function () {
          if (tl1 && tl1.scrollWidth > tl1.clientWidth + 1) {
            var short = clean(p.l1.replace(/\s*\d+\s*Taksit/i, ''));
            if (short) tl1.textContent = short;
          }
        });
      }
      inner.appendChild(txt);
      // Ürün sayfasında varyant değişince fiyat değişir: taksiti yeniden hesapla
      if (pe && !node._mgPriceWatch && !node.closest('.product-block') && 'MutationObserver' in window) {
        node._mgPriceWatch = true;
        new MutationObserver(function () {
          if (node.getAttribute('data-mg-kind') === 'taksit') render(node, inner, it);
        }).observe(pe, { childList: true, subtree: true, characterData: true });
      }
    } else {
      inner.appendChild(txt);
    }
  }

  function readItems(node) {
    try {
      var a = JSON.parse(node.getAttribute('data-efx-tags') || '[]');
      return Array.isArray(a) ? a.filter(function (x) { return x && clean(x.text); }) : [];
    } catch (e) {
      return [];
    }
  }

  function stop(node) {
    if (timers.has(node)) {
      clearInterval(timers.get(node));
      timers.delete(node);
    }
  }

  function setup(node, allowCreate) {
    if (!node || node.nodeType !== 1) return;
    // Sayfa ayrıştırılırken iç kap henüz gelmemiş olabilir; gelince yeniden çağrılır
    if (!node.querySelector('.custom-tag-inner') && allowCreate !== true) return;
    var raw = node.getAttribute('data-efx-tags') || '';
    if (node.dataset.mgInit === '1' && node._mgRaw === raw) return;

    var items = readItems(node);
    // Eski rotator bu düğümü atlasın
    node.dataset.efxInit = '1';
    if (!items.length) {
      node.style.display = 'none';
      return;
    }
    node.style.display = '';
    node._mgRaw = raw;
    node.dataset.mgInit = '1';
    node.classList.add('mg-cbox');
    if (node.matches(VIT_SEL)) {
      // Section'ın kendi etiket renkleri ID seçicisiyle !important yazılı; kutu
      // section'ın yazı rengini alsın diye zemin/renk/çerçeve satır içi ezilir.
      node.classList.add('mg-cbox--vitrin');
      node.style.setProperty('background', 'transparent', 'important');
      node.style.setProperty('color', 'var(--bs-title, #ffffff)', 'important');
      node.style.setProperty('border', '1px solid color-mix(in srgb, currentColor 45%, transparent)', 'important');
    }

    var inner = node.querySelector('.custom-tag-inner');
    if (!inner) {
      inner = el('div', 'custom-tag-inner');
      node.appendChild(inner);
    }

    var i = 0;
    node._mgItems = items;
    render(node, inner, items[0]);
    applySepetPrice(node.closest('.efx-bs__card') || node.closest('.product-block'), sepetFromItems(items));
    stop(node);
    watchAlign(node);

    if (!node._mgHoverBound) {
      node._mgHoverBound = true;
      node.addEventListener('pointerenter', function (e) {
        if (e.pointerType === 'mouse') node._mgHover = true;
      });
      node.addEventListener('pointerleave', function () {
        node._mgHover = false;
      });
    }

    if (items.length > 1) {
      timers.set(
        node,
        setInterval(function () {
          if (node._mgHover || Date.now() < (node._mgPause || 0)) return;
          if (document.hidden) return;
          inner.classList.add('is-fading');
          setTimeout(function () {
            i = (i + 1) % items.length;
            render(node, inner, items[i]);
            inner.classList.remove('is-fading');
          }, FADE);
        }, Math.max(1500, cfg('period', 3) * 1000))
      );
    }
  }

  // ---- Ürün sayfası: discount-badge.liquid output:'html' -> sabit .custom-tag kutuları
  var PDP_SEL = '.custom-tag:not(.custom-tag-rotator)';
  function setupPdp(node, force) {
    if (!node || node.nodeType !== 1 || node.dataset.mgPdp === '1') return;
    if (!cfg('pdp', true)) return;
    if (node.closest('.custom-tag-rotator')) return;
    // Sayfa ayrıştırılırken metin yarım gelmiş olabilir: kardeşi geldiyse kapanmıştır
    if (!force && document.readyState === 'loading' && !node.nextSibling) return;
    var text = clean(node.textContent);
    if (!text) return;
    node.dataset.mgPdp = '1';
    node.setAttribute('data-mg-text', text);
    node.classList.add('mg-cbox', 'mg-cbox--pdp');
    node.textContent = '';
    var inner = el('div', 'custom-tag-inner');
    node.appendChild(inner);
    render(node, inner, { text: text });
    var pp = parse({ text: text });
    if (pp.kind === 'sepet') applySepetPrice(pdpScope(node), rateOf(pp));
  }

  function teardown(node) {
    stop(node);
    if (node && node.dataset) {
      delete node.dataset.mgInit;
      node._mgRaw = null;
    }
  }

  // ---- Hiza yedeği: CSS zinciri bir yerde kırılırsa (tema/uygulama kuralı),
  // kutuyu kartın altına JS ile iter. CSS çalışıyorsa fark 0 çıkar, dokunmaz.
  var alignT = null;
  function alignAll() {
    if (!cfg('align', true)) return;
    var nodes = document.querySelectorAll(SEL + '.mg-cbox');
    var jobs = [];
    nodes.forEach(function (n) {
      if (n._mgExtra) { n.style.removeProperty('margin-top'); n._mgExtra = 0; }
    });
    nodes.forEach(function (n) {
      var pb = n.closest('.product-block');
      var det = n.parentElement;
      if (!pb || !det || !n.offsetParent) return;
      var diff = Math.round(pb.getBoundingClientRect().bottom - det.getBoundingClientRect().bottom);
      if (diff > 1) jobs.push([n, diff, parseFloat(getComputedStyle(n).marginTop) || 0]);
    });
    jobs.forEach(function (j) {
      j[0]._mgExtra = j[1];
      j[0].style.setProperty('margin-top', (j[2] + j[1]) + 'px', 'important');
    });
  }
  function scheduleAlign() {
    clearTimeout(alignT);
    alignT = setTimeout(function () { requestAnimationFrame(alignAll); }, 120);
  }
  var alignRO = 'ResizeObserver' in window ? new ResizeObserver(scheduleAlign) : null;
  function watchAlign(node) {
    var pb = node.closest && node.closest('.product-block');
    if (pb && alignRO && !pb._mgRO) { pb._mgRO = true; alignRO.observe(pb); }
    scheduleAlign();
  }
  window.addEventListener('resize', scheduleAlign);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(scheduleAlign);

  function scan(root) {
    (root || document).querySelectorAll(ROT_SEL).forEach(function (x) { setup(x, true); });
    (root || document).querySelectorAll(PDP_SEL).forEach(function (x) { setupPdp(x, true); });
  }

  var mo = new MutationObserver(function (muts) {
    for (var k = 0; k < muts.length; k++) {
      var m = muts[k];
      if (m.type === 'attributes') {
        if (m.target.matches && m.target.matches(ROT_SEL)) setup(m.target, true);
        continue;
      }
      m.addedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches(ROT_SEL)) setup(n);
        else if (n.classList.contains('custom-tag-inner') && n.parentElement && n.parentElement.matches(ROT_SEL)) setup(n.parentElement);
        if (n.querySelectorAll) n.querySelectorAll(ROT_SEL).forEach(function (x) { setup(x); });
        if (n.matches(PDP_SEL)) setupPdp(n);
        if (n.previousElementSibling && n.previousElementSibling.matches(PDP_SEL)) setupPdp(n.previousElementSibling);
        if (n.querySelectorAll) n.querySelectorAll(PDP_SEL).forEach(function (x) { setupPdp(x); });
      });
      m.removedNodes.forEach(function (n) {
        if (n.nodeType !== 1) return;
        if (n.matches(ROT_SEL)) teardown(n);
        if (n.querySelectorAll) n.querySelectorAll(ROT_SEL).forEach(teardown);
      });
    }
  });
  mo.observe(document.documentElement, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['data-efx-tags']
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  window.addEventListener('load', function () { scan(); });
  window.mgCboxInit = scan;
})();
